import {
    INACTIVITY_DELAY,
} from '../constants';

import { ActivityMonitor } from './ActivityMonitor';
import { TriggerGroup } from './InterfaceTriggerGroup';
import { handlersTriggers } from "./triggersAction";

export class TriggerExecutorGroup {
    activityMonitor: ActivityMonitor;
    nodeId: string;

    constructor(nodeId = '') {
        this.nodeId = nodeId;
    }

    setupTriggers(TriggerGroup: TriggerGroup, widgetToggleType: string) {
        const promises = TriggerGroup.triggers.map((trigger) => {
            if (trigger.type === INACTIVITY_DELAY && !this.activityMonitor) {
                this.activityMonitor = new ActivityMonitor();
            }
            return handlersTriggers[trigger.type]({
                trigger,
                nodeId: this.nodeId,
                toggleType: widgetToggleType,
                activityMonitor: this.activityMonitor,
            });
        });

        return Promise.all(promises);
    }
}